<form [formGroup]="form">
  <mat-form-field2 class="mat-block">
    <mat-label i18n>Task Name</mat-label>
    <input type="text" i18n-placeholder placeholder="Name of the task" matInput formControlName="name" required />
    <mat-error *ngIf="form.get('name').hasError('required')" i18n>Task Name is required</mat-error>
    <mat-error *ngIf="form.get('name').hasError('allNumbers')" i18n>Name cannot be numbers alone.</mat-error>
  </mat-form-field2>
  <mat-form-field2 class="mat-block">
    <mat-label i18n>Task List</mat-label>
    <input
      type="text"
      matInput
      formControlName="list"
      [matAutocomplete]="taskLists"
      i18n-placeholder
      placeholder="Select or enter a task list"
    />
    <mat-autocomplete #taskLists="matAutocomplete">
      <mat-option *ngFor="let list of filteredLists$ | async" [value]="list">{{ list }}</mat-option>
    </mat-autocomplete>
  </mat-form-field2>
  <div class="row" *ngIf="!hideDateFields">
    <div class="col-md-6">
      <div class="card p-3 h-100">
        <app-automation-date-form [form]="form.get('start')" label="Start Date"></app-automation-date-form>
        <mat-error *ngIf="form.get('start').hasError('invalid')" i18n>Due date may be after the start date</mat-error>
        <mat-error
          *ngIf="isBookingConfirmedOnBookingCreatedEvent(eventCtrl.value, form.get('start').get('base').value)"
          i18n
          >When an inquiry is created, the booking might not be confirmed, in which case this automation will be skipped
        </mat-error>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card p-3 h-100">
        <app-automation-date-form [form]="form.get('due')" label="Due Date"></app-automation-date-form>
        <mat-error *ngIf="form.get('due').hasError('invalid')" i18n>Due date may be after the start date</mat-error>
        <mat-error
          *ngIf="isBookingConfirmedOnBookingCreatedEvent(eventCtrl.value, form.get('due').get('base').value)"
          i18n
        >
          When an inquiry is created, the booking might not be confirmed, in which case this automation will be skipped
        </mat-error>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-3">
      <app-task-assignee-select [ctrl]="form.get('user_ids')"></app-task-assignee-select>
    </div>
    <div class="col-md-3">
      <mat-form-field2 class="mat-block">
        <mat-select formControlName="status" i18n-placeholder placeholder="Status" required>
          <mat-option *ngFor="let status of statuses" [value]="status.value">
            {{ status.label }}
          </mat-option>
        </mat-select>
      </mat-form-field2>
    </div>
    <div class="col-md-3">
      <app-timezone-select [ctrl]="form.get('timezone')"></app-timezone-select>
    </div>
    <div class="col-md-3">
      <app-form-tags
        formControlName="tags"
        label="Tags"
        i18n-matTooltip
        matTooltip="This will allow you to add arbitrary descriptors to this automation record which can then be used when filtering on various reports and calendars."
        matTooltipPosition="above"
      ></app-form-tags>
    </div>
  </div>

  <mat-form-field2 class="mat-block">
    <mat-label i18n>Task Notes</mat-label>
    <textarea
      matInput
      #notes
      rows="3"
      formControlName="notes"
      i18n-placeholder
      placeholder="Enter task details"
      cdkTextareaAutosize
      [cdkAutosizeMaxRows]="5"
    ></textarea>
    <mat-error *ngIf="form.get('notes').hasError('required')" i18n>Task Notes is required</mat-error>
  </mat-form-field2>
  <app-upload-box
    [options]="getUploadBoxOptions()"
    [showFileList]="false"
    *ngIf="attachments.length < maxAttachments"
    (complete)="onUploadComplete($event)"
  ></app-upload-box>
  <div *ngFor="let item of attachments; let i = index" class="d-flex align-items-center gap-3">
    <div class="text-primary text-xxl">
      <i class="" [ngClass]="item.name | fileIcon"></i>
    </div>
    <div class="mr-4">{{ item.name }}</div>
    <div class="flex-fill text-light">
      {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'HH:mm' }}* {{ item.user }}*
      {{ item.size | fileSize }}
    </div>
    <div>
      <a href="javascript:;" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)"
        ><i class="cs-icon cs-icon-download"></i>
      </a>
      <a href="javascript:;" class="btn btn-light-danger btn-sm" (click)="onDeleteAttachment(item)"
        ><i class="cs-icon cs-icon-trash"></i>
      </a>
    </div>
  </div>
</form>
